import React from 'react';

import EasyblocksTabs from './tabs';
import EasyblocksPageActions from './page-actions';
import EasyblocksItemActions from './item-actions';
import EasyblocksThemeSettings from './theme-settings';
import './overrides.scss';

export default class EasyblocksOverrides extends React.PureComponent {
  render() {
    return (
      <>
        <EasyblocksTabs {...this.props} />
        <EasyblocksPageActions {...this.props} />
        <EasyblocksItemActions {...this.props} />
        <EasyblocksThemeSettings {...this.props} />
      </>
    );
  }
}
